import {
  loggerMiddleware,
  RelayNetworkLayer,
  cacheMiddleware,
} from 'react-relay-network-modern/es';

import type { Middleware } from 'react-relay-network-modern/es';

import logger from '../../../config/app.logger';

import { getExtendedLogger } from '../../Logger';

import { LOGGER_NAME } from '../constants';

import minificationMiddleware from './middlewares/minification';
import operationNameMiddleware from './middlewares/operationName';

import type { NetworkOptions } from '../types';

const log = getExtendedLogger(LOGGER_NAME, logger);

export const createNetwork = (
  middlewares: Middleware[],
  { minification, cacheOptions, getPersistedQueriesMap, ...options }: NetworkOptions = {}
) => {
  const defaultMiddlewares = [
    loggerMiddleware({
      logger: log.bind(log, '[RELAY-API-CALL]'),
    }),
    operationNameMiddleware(),
    minificationMiddleware({
      minification: minification || false,
      getPersistedQueriesMap,
    }),
    cacheMiddleware(cacheOptions),
  ];

  return new RelayNetworkLayer([...middlewares, ...defaultMiddlewares], options);
};

export type { NetworkOptions };
